  var found_sl = setInterval(function(){
        if( $(".wrapinofgzc").length ){
            clearInterval(found_sl);
        }
 $(document).ready(function () {
            $(".wrapinofgzc").slick({
                dots: true,
                infinite: true,
                speed: 300,
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                  {
                   breakpoint: 992,
                   settings: 'unslick'
                  }
                ]
            });
     }, 200);
        });